import type { FallbackProps } from "react-error-boundary";
import { AppErrorBoundaryLayout } from "@/components/organisms/appErrorBoundaryLayout";

export const AppRootErrorFallbackTopLevel = ({
  error,
  resetErrorBoundary,
}: FallbackProps) => (
  <AppErrorBoundaryLayout
    error={error}
    resetErrorBoundary={resetErrorBoundary}
  />
);
